import { render } from "./megaOptions.vue?vue&type=template&id=24b3577f"
import script from "./megaOptions.vue?vue&type=script&lang=js"
export * from "./megaOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__